import { I18n } from '@calendly/i18n'
import { useSelector, useDispatch } from 'react-redux'

import {
  selectFilterItem,
  unselectFilterItem
} from 'actions/filters/selection'
import {
  createSelectedIdsSelector,
  createSelectedItemsSelector
} from 'selectors/filter_dropdown_menu'

import ItemList from './item_list'
import { GroupHeader } from './styles'

export default function SelectedGroup({ filterName, headerName }) {
  const dispatch = useDispatch()
  const selectedItems = useSelector(createSelectedItemsSelector(filterName))
  const selectedIds = useSelector(createSelectedIdsSelector(filterName))
  if (!selectedItems.length) { return null }

  function onItemChange(item, checked) {
    if (checked) {
      dispatch(selectFilterItem(filterName, item.group, item))
    } else {
      dispatch(unselectFilterItem(filterName, item.group, item))
    }
  }

  return (
    <>
      <GroupHeader>
        {headerName || I18n.t('publisher.scheduled_events.filters.selected_items')}
      </GroupHeader>
      <ItemList
        items={selectedItems}
        selectedIds={selectedIds}
        onChange={onItemChange}
      />
    </>
  )
}
